import { Stack } from "@mantine/core"
import { DateInput } from "@mantine/dates"
import { LabelWithTooltip } from "@tfg/ui"
import dayjs from "dayjs"

import { FormFieldConfig } from "~/pages/Admin/components/form.types"

export const DateInputField = (field: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {field.tooltip && (
      <LabelWithTooltip
        label={field.label}
        hoverHelperText={field.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={field.required ?? false}
      />
    )}
    <DateInput
      key={field.name}
      label={!field.tooltip ? field.label : undefined}
      placeholder={field.placeholder}
      classNames={field.customClass}
      clearable
      dateParser={(input) => {
        return dayjs(input, "DD/MM/YYYY").toDate()
      }}
      valueFormat="DD/MM/YYYY"
      onChange={(value) => {
        form.setFieldValue(field.name, value ? dayjs(value).toDate() : null)
      }}
      value={
        form.getInputProps(field.name).value
          ? new Date(form.getInputProps(field.name).value)
          : null
      }
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      error={!form.isValid(field.name) && form.isTouched(field.name)}
      disabled={field.disabled}
    />
  </Stack>
)
